module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "scroll-goods"
  }, [_c('div', {
    staticClass: "row-title-box"
  }, [(_vm.title) ? _c('div', {
    staticClass: "row-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "scroll-box"
  }, _vm._l((_vm.content), function(item, index) {
    return _c('div', {
      staticClass: "scroll-one",
      on: {
        "click": function($event) {
          return _vm.goGoodsDetail(item.url.name, item.url.query.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.goods.pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "scroll-goods-name show-one-row"
    }, [_vm._v(_vm._s(item.goods.title))]), _vm._v(" "), _c('div', {
      staticClass: "scroll-goods-price-box"
    }, [_c('div', {
      staticClass: "scroll-goods-price"
    }, [_c('div', {
      staticClass: "goods-list0-price"
    }, [_vm._v("¥")]), _vm._v(" "), _c('div', {
      staticClass: "goods-list1-price"
    }, [_vm._v(_vm._s(item.goods.price_range[0]))]), _vm._v(" "), (item.goods.price_range_2) ? _c('div', {
      staticClass: "goods-list0-price"
    }, [_vm._v("." + _vm._s(item.goods.price_range_2))]) : _vm._e()]), _vm._v(" "), (item.goods.max_seller_reward > 0) ? _c('div', {
      staticClass: "scroll-goods-item0-seller-price"
    }, [_c('div', {
      staticClass: "fan"
    }, [_vm._v("赚")]), _vm._v(" "), _c('div', {
      staticClass: "seller-price"
    }, [_vm._v("¥" + _vm._s(item.goods.max_seller_reward / 100))])]) : _vm._e()])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-972c1c42","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GoodsList0.vue
// module id = 2557
// module chunks = 0